import { z } from 'zod';
var Intake = z.object({
  intakeId: z.number().or(z.string()),
  intakeStatus: z.string(),
  openDate: z.string().nullish(),
  startDate: z.string(),
  submissionDeadline: z.string().nullish(),
  programType: z["enum"](['main', 'esl']),
  seatAvailability: z.object({
    score: z.coerce.number(),
    determination: z.string(),
    successScoreVersion: z.number().nullish()
  }).nullish()
});
export var IntakeResponse = z.object({
  type: z.literal('intake'),
  id: z.string(),
  attributes: Intake
});